// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles." + "21077d844cb6bb3a70b7" + ".css";
};